export default [
  {
    "meta": {
        "date_filed": "07/31/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for the Quarter Ending June 2018</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017767441'>997</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 998,
        "docket_seq": "998.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017769532",
        "purchased": 2
    },
    "text": {
        "date_filed": "07/31/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for the Quarter Ending June 2018</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017767441'>997</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 998,
        "docket_seq": "998.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017769532"
    }
},
{
    "meta": {
        "date_filed": "07/30/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 997,
        "date_terminated": null,
        "docket_seq": "997.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017767441",
        "purchased": 2
    },
    "text": {
        "date_filed": "07/30/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 997,
        "date_terminated": null,
        "docket_seq": "997.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017767441"
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017727673",
        "date_filed": "07/10/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 996,
        "docket_text": "Records Transmittal & Receipt - SF135. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_seq": "996.00000",
        "date_terminated": null,
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017727673",
        "date_filed": "07/10/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 996,
        "docket_text": "Records Transmittal & Receipt - SF135. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_seq": "996.00000",
        "date_terminated": null
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "07/02/2018",
        "docket_seq": "995.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 995,
        "docket_text": "Transcript regarding Hearing Held 6/26/18 RE: Final Decree. Remote electronic access to the transcript is restricted until 10/1/2018. The transcript may be viewed at the Bankruptcy Court Clerk&#039;s Office. For information about how to contact the transcriber, call the Clerk&#039;s Office or Contact the Court Reporter/Transcriber, eScribers, LLC at Telephone number 973-406-2250. Notice of Intent to Request Redaction Deadline Due By 7/9/2018. Redaction Request Due By 7/23/2018. Redacted Transcript Submission Due By 8/2/2018. Transcript access will be restricted through 10/1/2018. (Murin, Leslie)",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017714695"
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "07/02/2018",
        "docket_seq": "995.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 995,
        "docket_text": "Transcript regarding Hearing Held 6/26/18 RE: Final Decree. Remote electronic access to the transcript is restricted until 10/1/2018. The transcript may be viewed at the Bankruptcy Court Clerk&#039;s Office. For information about how to contact the transcriber, call the Clerk&#039;s Office or Contact the Court Reporter/Transcriber, eScribers, LLC at Telephone number 973-406-2250. Notice of Intent to Request Redaction Deadline Due By 7/9/2018. Redaction Request Due By 7/23/2018. Redacted Transcript Submission Due By 8/2/2018. Transcript access will be restricted through 10/1/2018. (Murin, Leslie)",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017714695",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705842",
        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>) (Garabato, Sid)",
        "docket_no": 994,
        "timestamp": 1545958158.50098,
        "docket_seq": "994.00000",
        "date_terminated": null,
        "date_filed": "06/27/2018",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705842",
        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017704391'>988</a>) (Garabato, Sid)",
        "docket_no": 994,
        "timestamp": 1545958158.50098,
        "docket_seq": "994.00000",
        "date_terminated": null,
        "date_filed": "06/27/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "text": {
        "timestamp": 1545958158.50098,
        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (Garabato, Sid)",
        "docket_no": 993,
        "date_terminated": null,
        "docket_seq": "993.00000",
        "date_filed": "06/27/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705834"
    },
    "meta": {
        "timestamp": 1545958158.50098,
        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (Garabato, Sid)",
        "docket_no": 993,
        "date_terminated": null,
        "docket_seq": "993.00000",
        "date_filed": "06/27/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705834",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705607",
        "case_uuid": "debke_156594",
        "date_filed": "06/27/2018",
        "date_terminated": null,
        "docket_seq": "992.00000",
        "docket_text": "Final Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 992,
        "timestamp": 1545958158.50098
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705607",
        "case_uuid": "debke_156594",
        "date_filed": "06/27/2018",
        "date_terminated": null,
        "docket_seq": "992.00000",
        "docket_text": "Final Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 992,
        "timestamp": 1545958158.50098,
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705595",
        "docket_no": 991,
        "docket_text": "Final Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "991.00000",
        "date_filed": "06/27/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705595",
        "docket_no": 991,
        "docket_text": "Final Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "991.00000",
        "date_filed": "06/27/2018",
        "case_uuid": "debke_156594"
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "date_terminated": null,
        "docket_seq": "990.00000",
        "docket_text": "Corrected Objection to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018 (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by Robert Dalton (Murin, Leslie) Modified Text on 6/29/2018 (LB).",
        "docket_no": 990,
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705406"
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "date_terminated": null,
        "docket_seq": "990.00000",
        "docket_text": "Corrected Objection to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018 (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by Robert Dalton (Murin, Leslie) Modified Text on 6/29/2018 (LB).",
        "docket_no": 990,
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705406",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705021",
        "docket_seq": "989.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 989,
        "docket_text": "Certificate of Service <i>to Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017698607'>983</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017705021",
        "docket_seq": "989.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 989,
        "docket_text": "Certificate of Service <i>to Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017698607'>983</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018"
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704391",
        "timestamp": 1545958158.50098,
        "docket_text": "Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services. (related document <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Order Signed on 6/26/2018. (DMC)",
        "docket_no": 988,
        "docket_seq": "988.00000",
        "date_terminated": null,
        "date_filed": "06/26/2018",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704391",
        "timestamp": 1545958158.50098,
        "docket_text": "Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services. (related document <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Order Signed on 6/26/2018. (DMC)",
        "docket_no": 988,
        "docket_seq": "988.00000",
        "date_terminated": null,
        "date_filed": "06/26/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_seq": "987.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 987,
        "docket_text": "Hearing Held 6/26/2018 at 2:00 p.m. Court Sign-In Sheet (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (DMC)",
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704376",
        "purchased": 0
    },
    "text": {
        "docket_seq": "987.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 987,
        "docket_text": "Hearing Held 6/26/2018 at 2:00 p.m. Court Sign-In Sheet (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017697669'>982</a>) (DMC)",
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704376"
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "docket_seq": "986.00000",
        "date_terminated": null,
        "docket_no": 986,
        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>) (Garabato, Sid)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704233"
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "docket_seq": "986.00000",
        "date_terminated": null,
        "docket_no": 986,
        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017696321'>981</a>) (Garabato, Sid)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704233",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704162",
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "docket_seq": "985.00000",
        "date_terminated": null,
        "docket_text": "PDF with attached Audio File. Instructions for opening the attached Audio File can be found on the Court&#039;s website under Case Info/Digital Audio in CM/ECF. Court Date & Time [ 6/26/2018 2:00:10 PM ]. File Size [ 9372 KB ]. Run Time [ 00:39:03 ]. (audio_admin).",
        "docket_no": 985,
        "timestamp": 1545958158.50098,
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017704162",
        "case_uuid": "debke_156594",
        "date_filed": "06/26/2018",
        "docket_seq": "985.00000",
        "date_terminated": null,
        "docket_text": "PDF with attached Audio File. Instructions for opening the attached Audio File can be found on the Court&#039;s website under Case Info/Digital Audio in CM/ECF. Court Date & Time [ 6/26/2018 2:00:10 PM ]. File Size [ 9372 KB ]. Run Time [ 00:39:03 ]. (audio_admin).",
        "docket_no": 985,
        "timestamp": 1545958158.50098
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "06/25/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545950343.0324,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 984,
        "docket_seq": "984.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "06/25/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545950343.0324,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 984,
        "docket_seq": "984.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017698607",
        "docket_text": "Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date. (Related Doc # <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Order Signed on 6/22/2018. (DMC)",
        "docket_no": 983,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "983.00000",
        "date_filed": "06/22/2018",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017698607",
        "docket_text": "Order Granting Liquidating Trustee&#039;s Motion for Entry of An Order Extending The Trust Termination Date. (Related Doc # <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Order Signed on 6/22/2018. (DMC)",
        "docket_no": 983,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "983.00000",
        "date_filed": "06/22/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017697669",
        "case_uuid": "debke_156594",
        "date_filed": "06/22/2018",
        "date_terminated": null,
        "docket_seq": "982.00000",
        "docket_no": 982,
        "docket_text": "Notice of Agenda of Matters Scheduled for Hearing Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017697669",
        "case_uuid": "debke_156594",
        "date_filed": "06/22/2018",
        "date_terminated": null,
        "docket_seq": "982.00000",
        "docket_no": 982,
        "docket_text": "Notice of Agenda of Matters Scheduled for Hearing Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Steele, Amanda)",
        "timestamp": 1545958158.50098
    }
},
{
    "text": {
        "docket_no": 981,
        "docket_text": "Reply <i>// Reorganized Debtor&#039;s Reply in Support of Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KiOR, Inc. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117696322'>1</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117696323'>2</a> Exhibit B) (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "981.00000",
        "date_filed": "06/21/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017696321"
    },
    "meta": {
        "docket_no": 981,
        "docket_text": "Reply <i>// Reorganized Debtor&#039;s Reply in Support of Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KiOR, Inc. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117696322'>1</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117696323'>2</a> Exhibit B) (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "981.00000",
        "date_filed": "06/21/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017696321",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_seq": "980.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 980,
        "docket_text": "Certificate of No Objection <i>to Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "case_uuid": "debke_156594",
        "date_filed": "06/21/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017695289",
        "purchased": 0
    },
    "text": {
        "docket_seq": "980.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 980,
        "docket_text": "Certificate of No Objection <i>to Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017663850'>974</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017692211'>979</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "case_uuid": "debke_156594",
        "date_filed": "06/21/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017695289"
    }
},
{
    "text": {
        "timestamp": 1545958158.50098,
        "docket_no": 979,
        "docket_text": "Objection <i>to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015029817'>328</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015240428'>588</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015266529'>618</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015267619'>621</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) Filed by Robert Dalton (DMC)",
        "docket_seq": "979.00000",
        "date_terminated": null,
        "date_filed": "06/20/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017692211"
    },
    "meta": {
        "timestamp": 1545958158.50098,
        "docket_no": 979,
        "docket_text": "Objection <i>to the Debtors Motion to Close and Exit This Chapter 11 Bankruptcy Case and Support for the Liquidating Trustee to have extended Termination Date for 60 days past the Hearing Date, June 26, 2018.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015029817'>328</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015240428'>588</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015266529'>618</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042015267619'>621</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) Filed by Robert Dalton (DMC)",
        "docket_seq": "979.00000",
        "date_terminated": null,
        "date_filed": "06/20/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017692211",
        "purchased": 0
    }
},
{
    "text": {
        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) (Garabato, Sid)",
        "docket_no": 978,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "978.00000",
        "date_filed": "06/11/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670418"
    },
    "meta": {
        "docket_text": "Affidavit/Declaration of Service <i>of Forrest Kuffer</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662744'>972</a>) (Garabato, Sid)",
        "docket_no": 978,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "978.00000",
        "date_filed": "06/11/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670418",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670392",
        "case_uuid": "debke_156594",
        "date_filed": "06/11/2018",
        "docket_seq": "977.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 977,
        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>) (Garabato, Sid)"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017670392",
        "case_uuid": "debke_156594",
        "date_filed": "06/11/2018",
        "docket_seq": "977.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 977,
        "docket_text": "Affidavit/Declaration of Service <i>of Konstantina Haidopoulos</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>). Filed by Epiq Bankruptcy Solutions LLC. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017657922'>961</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017658258'>962</a>) (Garabato, Sid)",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "06/11/2018",
        "case_uuid": "debke_156594",
        "docket_no": 976,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950342.25225,
        "docket_seq": "976.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "06/11/2018",
        "case_uuid": "debke_156594",
        "docket_no": 976,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950342.25225,
        "docket_seq": "976.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017668507",
        "date_filed": "06/08/2018",
        "case_uuid": "debke_156594",
        "docket_no": 975,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662482'>970</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662485'>971</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "975.00000"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017668507",
        "date_filed": "06/08/2018",
        "case_uuid": "debke_156594",
        "docket_no": 975,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017662482'>970</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017662485'>971</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "975.00000",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663850",
        "docket_text": "Notice of Hearing <i>/[CORRECTED] Notice of Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117663851'>1</a> Certificate of Service) (Gwynne, Kurt)",
        "docket_no": 974,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "974.00000",
        "date_filed": "06/07/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663850",
        "docket_text": "Notice of Hearing <i>/[CORRECTED] Notice of Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660441'>968</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117663851'>1</a> Certificate of Service) (Gwynne, Kurt)",
        "docket_no": 974,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "974.00000",
        "date_filed": "06/07/2018",
        "case_uuid": "debke_156594"
    }
},
{
    "meta": {
        "date_filed": "06/07/2018",
        "case_uuid": "debke_156594",
        "docket_no": 973,
        "docket_text": "Certificate of Service <i>to Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660420'>967</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "timestamp": 1545958158.50098,
        "docket_seq": "973.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663831",
        "purchased": 0
    },
    "text": {
        "date_filed": "06/07/2018",
        "case_uuid": "debke_156594",
        "docket_no": 973,
        "docket_text": "Certificate of Service <i>to Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017660420'>967</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "timestamp": 1545958158.50098,
        "docket_seq": "973.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017663831"
    }
},
{
    "text": {
        "docket_seq": "972.00000",
        "date_terminated": null,
        "docket_no": 972,
        "docket_text": "Motion for Final Decree <i>//Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117662745'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117662746'>2</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117662747'>3</a> Exhibit B) (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "case_uuid": "debke_156594",
        "date_filed": "06/06/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662744"
    },
    "meta": {
        "docket_seq": "972.00000",
        "date_terminated": null,
        "docket_no": 972,
        "docket_text": "Motion for Final Decree <i>//Reorganized Debtor&#039;s Motion for Order (I) Granting Final Decree Closing the Chapter 11 Case of KiOR, Inc. and (II) Terminating Claims and Noticing Services</i> Filed by KiOR, Inc.. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117662745'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117662746'>2</a> Exhibit A # <a href='https://ecf.deb.uscourts.gov/doc1/042117662747'>3</a> Exhibit B) (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "case_uuid": "debke_156594",
        "date_filed": "06/06/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662744",
        "purchased": 0
    }
},
{
    "text": {
        "date_filed": "06/06/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 971,
        "date_terminated": null,
        "docket_seq": "971.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662485"
    },
    "meta": {
        "date_filed": "06/06/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2018</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 971,
        "date_terminated": null,
        "docket_seq": "971.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662485",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662482",
        "date_filed": "06/06/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>(Amended) for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 970,
        "docket_seq": "970.00000",
        "date_terminated": null,
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017662482",
        "date_filed": "06/06/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>(Amended) for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 970,
        "docket_seq": "970.00000",
        "date_terminated": null
    }
},
{
    "meta": {
        "date_terminated": null,
        "docket_seq": "969.00000",
        "docket_no": 969,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017659177'>963</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659180'>964</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659195'>965</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659208'>966</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "case_uuid": "debke_156594",
        "date_filed": "06/06/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017661551",
        "purchased": 0
    },
    "text": {
        "date_terminated": null,
        "docket_seq": "969.00000",
        "docket_no": 969,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Quarterly Reports</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042017659177'>963</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659180'>964</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659195'>965</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042017659208'>966</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "case_uuid": "debke_156594",
        "date_filed": "06/06/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017661551"
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660441",
        "docket_seq": "968.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_text": "Motion to Extend <i>/Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117660442'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117660443'>2</a> Proposed Form of Order # <a href='https://ecf.deb.uscourts.gov/doc1/042117660444'>3</a> Certificate of Service) (Gwynne, Kurt)",
        "docket_no": 968,
        "case_uuid": "debke_156594",
        "date_filed": "06/05/2018"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660441",
        "docket_seq": "968.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_text": "Motion to Extend <i>/Liquidating Trustee&#039;s Motion for Entry of an Order Extending the Trust Termination Date</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 6/26/2018 at 02:00 PM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. Objections due by 6/19/2018. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042117660442'>1</a> Notice # <a href='https://ecf.deb.uscourts.gov/doc1/042117660443'>2</a> Proposed Form of Order # <a href='https://ecf.deb.uscourts.gov/doc1/042117660444'>3</a> Certificate of Service) (Gwynne, Kurt)",
        "docket_no": 968,
        "case_uuid": "debke_156594",
        "date_filed": "06/05/2018",
        "purchased": 0
    }
},
{
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "06/05/2018",
        "docket_seq": "967.00000",
        "date_terminated": null,
        "docket_no": 967,
        "docket_text": "Post-Confirmation Report <i>/ Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660420",
        "purchased": 0
    },
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "06/05/2018",
        "docket_seq": "967.00000",
        "date_terminated": null,
        "docket_no": 967,
        "docket_text": "Post-Confirmation Report <i>/ Report and Declaration of Kurt F. Gwynne, as Liquidating Trustee, Regarding Activities of the KiOR Liquidating Trust</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Gwynne, Kurt)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017660420"
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659208",
        "timestamp": 1545958158.50098,
        "docket_no": 966,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "date_terminated": null,
        "docket_seq": "966.00000",
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659208",
        "timestamp": 1545958158.50098,
        "docket_no": 966,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending December 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "date_terminated": null,
        "docket_seq": "966.00000",
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "meta": {
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 965,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending September 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "date_terminated": null,
        "docket_seq": "965.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659195",
        "purchased": 0
    },
    "text": {
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 965,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending September 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "date_terminated": null,
        "docket_seq": "965.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659195"
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659180",
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 964,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_seq": "964.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659180",
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 964,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending June 30, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_seq": "964.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659177",
        "docket_no": 963,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "docket_seq": "963.00000",
        "date_terminated": null,
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017659177",
        "docket_no": 963,
        "docket_text": "Post-Confirmation Report <i>for the Quarter Ending March 31, 2017</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "timestamp": 1545958158.50098,
        "docket_seq": "963.00000",
        "date_terminated": null,
        "date_filed": "06/05/2018",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "06/04/2018",
        "docket_seq": "962.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 962,
        "docket_text": "Order Scheduling Omnibus Hearings. All hearings will be held at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom #6, Wilmington, Delaware . Omnibus Hearings scheduled for 6/26/2018 at 02:00 PM. Signed on 6/4/2018. (CAS)",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017658258"
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "06/04/2018",
        "docket_seq": "962.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_no": 962,
        "docket_text": "Order Scheduling Omnibus Hearings. All hearings will be held at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom #6, Wilmington, Delaware . Omnibus Hearings scheduled for 6/26/2018 at 02:00 PM. Signed on 6/4/2018. (CAS)",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017658258",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017657922",
        "date_terminated": null,
        "docket_seq": "961.00000",
        "timestamp": 1545958158.50098,
        "docket_no": 961,
        "docket_text": "Certification of Counsel <i>Regarding Scheduling of Omnibus Hearing Date</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "case_uuid": "debke_156594",
        "date_filed": "06/04/2018",
        "purchased": 0
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017657922",
        "date_terminated": null,
        "docket_seq": "961.00000",
        "timestamp": 1545958158.50098,
        "docket_no": 961,
        "docket_text": "Certification of Counsel <i>Regarding Scheduling of Omnibus Hearing Date</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "case_uuid": "debke_156594",
        "date_filed": "06/04/2018"
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "05/29/2018",
        "date_terminated": null,
        "docket_seq": "960.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 960,
        "timestamp": 1545950339.42332,
        "docket_uri": null
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "05/29/2018",
        "date_terminated": null,
        "docket_seq": "960.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 960,
        "timestamp": 1545950339.42332,
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "05/14/2018",
        "case_uuid": "debke_156594",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 959,
        "timestamp": 1545950339.38072,
        "docket_seq": "959.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "05/14/2018",
        "case_uuid": "debke_156594",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 959,
        "timestamp": 1545950339.38072,
        "docket_seq": "959.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_seq": "958.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 958,
        "timestamp": 1545950339.32642,
        "case_uuid": "debke_156594",
        "date_filed": "04/30/2018",
        "docket_uri": null
    },
    "meta": {
        "docket_seq": "958.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 958,
        "timestamp": 1545950339.32642,
        "case_uuid": "debke_156594",
        "date_filed": "04/30/2018",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "meta": {
        "date_filed": "04/23/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 957,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_seq": "957.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568124",
        "purchased": 0
    },
    "text": {
        "date_filed": "04/23/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 957,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_seq": "957.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568124"
    }
},
{
    "text": {
        "docket_no": 956,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "956.00000",
        "date_filed": "04/23/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568119"
    },
    "meta": {
        "docket_no": 956,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "956.00000",
        "date_filed": "04/23/2018",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017568119",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "04/16/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545950339.15873,
        "docket_no": 955,
        "docket_text": "Standing Order/Transcripts",
        "date_terminated": null,
        "docket_seq": "955.00000"
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "04/16/2018",
        "case_uuid": "debke_156594",
        "timestamp": 1545950339.15873,
        "docket_no": 955,
        "docket_text": "Standing Order/Transcripts",
        "date_terminated": null,
        "docket_seq": "955.00000",
        "purchased": 0
    }
},
{
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "04/02/2018",
        "docket_seq": "954.00000",
        "date_terminated": null,
        "docket_no": 954,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950339.11511,
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "04/02/2018",
        "docket_seq": "954.00000",
        "date_terminated": null,
        "docket_no": 954,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950339.11511,
        "docket_uri": null
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "03/19/2018",
        "date_terminated": null,
        "docket_seq": "953.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 953,
        "timestamp": 1545950339.04632,
        "docket_uri": null
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "03/19/2018",
        "date_terminated": null,
        "docket_seq": "953.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 953,
        "timestamp": 1545950339.04632,
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "03/05/2018",
        "docket_seq": "952.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 952,
        "timestamp": 1545950338.99167,
        "docket_uri": null
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "03/05/2018",
        "docket_seq": "952.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 952,
        "timestamp": 1545950338.99167,
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "02/20/2018",
        "case_uuid": "debke_156594",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 951,
        "timestamp": 1545950338.88714,
        "docket_seq": "951.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "02/20/2018",
        "case_uuid": "debke_156594",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 951,
        "timestamp": 1545950338.88714,
        "docket_seq": "951.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_seq": "950.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 950,
        "timestamp": 1545950338.84431,
        "case_uuid": "debke_156594",
        "date_filed": "02/05/2018",
        "docket_uri": null
    },
    "meta": {
        "docket_seq": "950.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 950,
        "timestamp": 1545950338.84431,
        "case_uuid": "debke_156594",
        "date_filed": "02/05/2018",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "docket_seq": "949.00000",
        "date_terminated": null,
        "timestamp": 1545950338.76031,
        "docket_no": 949,
        "docket_text": "Standing Order/Transcripts",
        "case_uuid": "debke_156594",
        "date_filed": "01/22/2018"
    },
    "meta": {
        "docket_uri": null,
        "docket_seq": "949.00000",
        "date_terminated": null,
        "timestamp": 1545950338.76031,
        "docket_no": 949,
        "docket_text": "Standing Order/Transcripts",
        "case_uuid": "debke_156594",
        "date_filed": "01/22/2018",
        "purchased": 0
    }
},
{
    "text": {
        "date_terminated": null,
        "docket_seq": "948.00000",
        "docket_no": 948,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "case_uuid": "debke_156594",
        "date_filed": "01/17/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357891"
    },
    "meta": {
        "date_terminated": null,
        "docket_seq": "948.00000",
        "docket_no": 948,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "case_uuid": "debke_156594",
        "date_filed": "01/17/2018",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357891",
        "purchased": 1
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357882",
        "date_filed": "01/17/2018",
        "case_uuid": "debke_156594",
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 947,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "947.00000"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017357882",
        "date_filed": "01/17/2018",
        "case_uuid": "debke_156594",
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 947,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "947.00000",
        "purchased": 1
    }
},
{
    "text": {
        "docket_uri": null,
        "date_terminated": null,
        "docket_seq": "946.00000",
        "docket_no": 946,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950338.54274,
        "case_uuid": "debke_156594",
        "date_filed": "01/08/2018"
    },
    "meta": {
        "docket_uri": null,
        "date_terminated": null,
        "docket_seq": "946.00000",
        "docket_no": 946,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950338.54274,
        "case_uuid": "debke_156594",
        "date_filed": "01/08/2018",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "case_uuid": "debke_156594",
        "date_filed": "12/11/2017",
        "docket_seq": "945.00000",
        "date_terminated": null,
        "docket_no": 945,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950338.49636
    },
    "meta": {
        "docket_uri": null,
        "case_uuid": "debke_156594",
        "date_filed": "12/11/2017",
        "docket_seq": "945.00000",
        "date_terminated": null,
        "docket_no": 945,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950338.49636,
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": null,
        "date_terminated": null,
        "docket_seq": "944.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 944,
        "timestamp": 1545950338.42577,
        "case_uuid": "debke_156594",
        "date_filed": "11/27/2017",
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "date_terminated": null,
        "docket_seq": "944.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 944,
        "timestamp": 1545950338.42577,
        "case_uuid": "debke_156594",
        "date_filed": "11/27/2017"
    }
},
{
    "text": {
        "docket_seq": "943.00000",
        "date_terminated": null,
        "timestamp": 1545950338.37841,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 943,
        "case_uuid": "debke_156594",
        "date_filed": "11/13/2017",
        "docket_uri": null
    },
    "meta": {
        "docket_seq": "943.00000",
        "date_terminated": null,
        "timestamp": 1545950338.37841,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 943,
        "case_uuid": "debke_156594",
        "date_filed": "11/13/2017",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "meta": {
        "date_filed": "10/30/2017",
        "case_uuid": "debke_156594",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 942,
        "timestamp": 1545950338.32783,
        "docket_seq": "942.00000",
        "date_terminated": null,
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "date_filed": "10/30/2017",
        "case_uuid": "debke_156594",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 942,
        "timestamp": 1545950338.32783,
        "docket_seq": "942.00000",
        "date_terminated": null,
        "docket_uri": null
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "10/16/2017",
        "date_terminated": null,
        "docket_seq": "941.00000",
        "timestamp": 1545950338.29227,
        "docket_no": 941,
        "docket_text": "Standing Order/Transcripts",
        "docket_uri": null
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "10/16/2017",
        "date_terminated": null,
        "docket_seq": "941.00000",
        "timestamp": 1545950338.29227,
        "docket_no": 941,
        "docket_text": "Standing Order/Transcripts",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142323",
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 940,
        "docket_seq": "940.00000",
        "date_terminated": null,
        "date_filed": "10/12/2017",
        "case_uuid": "debke_156594",
        "purchased": 1
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142323",
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 940,
        "docket_seq": "940.00000",
        "date_terminated": null,
        "date_filed": "10/12/2017",
        "case_uuid": "debke_156594"
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142316",
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 939,
        "timestamp": 1545958158.50098,
        "docket_seq": "939.00000",
        "date_terminated": null,
        "date_filed": "10/12/2017",
        "case_uuid": "debke_156594",
        "purchased": 1
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042017142316",
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 939,
        "timestamp": 1545958158.50098,
        "docket_seq": "939.00000",
        "date_terminated": null,
        "date_filed": "10/12/2017",
        "case_uuid": "debke_156594"
    }
},
{
    "meta": {
        "docket_uri": null,
        "case_uuid": "debke_156594",
        "date_filed": "10/02/2017",
        "docket_seq": "938.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 938,
        "timestamp": 1545950338.0455,
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "case_uuid": "debke_156594",
        "date_filed": "10/02/2017",
        "docket_seq": "938.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 938,
        "timestamp": 1545950338.0455
    }
},
{
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "09/18/2017",
        "date_terminated": null,
        "docket_seq": "937.00000",
        "timestamp": 1545950337.94578,
        "docket_no": 937,
        "docket_text": "Standing Order/Transcripts",
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "09/18/2017",
        "date_terminated": null,
        "docket_seq": "937.00000",
        "timestamp": 1545950337.94578,
        "docket_no": 937,
        "docket_text": "Standing Order/Transcripts",
        "docket_uri": null
    }
},
{
    "meta": {
        "docket_uri": null,
        "case_uuid": "debke_156594",
        "date_filed": "09/05/2017",
        "date_terminated": null,
        "docket_seq": "936.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 936,
        "timestamp": 1545950337.91007,
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "case_uuid": "debke_156594",
        "date_filed": "09/05/2017",
        "date_terminated": null,
        "docket_seq": "936.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 936,
        "timestamp": 1545950337.91007
    }
},
{
    "text": {
        "docket_uri": null,
        "docket_seq": "935.00000",
        "date_terminated": null,
        "timestamp": 1545950337.87544,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 935,
        "case_uuid": "debke_156594",
        "date_filed": "08/21/2017"
    },
    "meta": {
        "docket_uri": null,
        "docket_seq": "935.00000",
        "date_terminated": null,
        "timestamp": 1545950337.87544,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 935,
        "case_uuid": "debke_156594",
        "date_filed": "08/21/2017",
        "purchased": 0
    }
},
{
    "meta": {
        "docket_seq": "934.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 934,
        "timestamp": 1545950337.81194,
        "case_uuid": "debke_156594",
        "date_filed": "07/24/2017",
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "docket_seq": "934.00000",
        "date_terminated": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 934,
        "timestamp": 1545950337.81194,
        "case_uuid": "debke_156594",
        "date_filed": "07/24/2017",
        "docket_uri": null
    }
},
{
    "text": {
        "docket_seq": "933.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 933,
        "case_uuid": "debke_156594",
        "date_filed": "07/17/2017",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951355"
    },
    "meta": {
        "docket_seq": "933.00000",
        "date_terminated": null,
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 933,
        "case_uuid": "debke_156594",
        "date_filed": "07/17/2017",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951355",
        "purchased": 1
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "07/17/2017",
        "date_terminated": null,
        "docket_seq": "932.00000",
        "docket_no": 932,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951352"
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "07/17/2017",
        "date_terminated": null,
        "docket_seq": "932.00000",
        "docket_no": 932,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016951352",
        "purchased": 1
    }
},
{
    "meta": {
        "docket_uri": null,
        "timestamp": 1545950337.60993,
        "docket_no": 931,
        "docket_text": "Standing Order/Transcripts",
        "docket_seq": "931.00000",
        "date_terminated": null,
        "date_filed": "07/10/2017",
        "case_uuid": "debke_156594",
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "timestamp": 1545950337.60993,
        "docket_no": 931,
        "docket_text": "Standing Order/Transcripts",
        "docket_seq": "931.00000",
        "date_terminated": null,
        "date_filed": "07/10/2017",
        "case_uuid": "debke_156594"
    }
},
{
    "text": {
        "docket_uri": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 930,
        "timestamp": 1545950337.57022,
        "date_terminated": null,
        "docket_seq": "930.00000",
        "date_filed": "06/26/2017",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": null,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 930,
        "timestamp": 1545950337.57022,
        "date_terminated": null,
        "docket_seq": "930.00000",
        "date_filed": "06/26/2017",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "06/12/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545950337.52552,
        "docket_no": 929,
        "docket_text": "Standing Order/Transcripts",
        "docket_seq": "929.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "06/12/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545950337.52552,
        "docket_no": 929,
        "docket_text": "Standing Order/Transcripts",
        "docket_seq": "929.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "05/30/2017",
        "date_terminated": null,
        "docket_seq": "928.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 928,
        "timestamp": 1545950337.15763,
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "05/30/2017",
        "date_terminated": null,
        "docket_seq": "928.00000",
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 928,
        "timestamp": 1545950337.15763,
        "docket_uri": null
    }
},
{
    "meta": {
        "docket_uri": null,
        "docket_seq": "927.00000",
        "date_terminated": null,
        "timestamp": 1545950336.99531,
        "docket_no": 927,
        "docket_text": "Standing Order/Transcripts",
        "case_uuid": "debke_156594",
        "date_filed": "05/15/2017",
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "docket_seq": "927.00000",
        "date_terminated": null,
        "timestamp": 1545950336.99531,
        "docket_no": 927,
        "docket_text": "Standing Order/Transcripts",
        "case_uuid": "debke_156594",
        "date_filed": "05/15/2017"
    }
},
{
    "text": {
        "docket_uri": null,
        "date_filed": "05/05/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545950336.94236,
        "docket_no": 926,
        "docket_text": "Standing Order/Transcripts",
        "docket_seq": "926.00000",
        "date_terminated": null
    },
    "meta": {
        "docket_uri": null,
        "date_filed": "05/05/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545950336.94236,
        "docket_no": 926,
        "docket_text": "Standing Order/Transcripts",
        "docket_seq": "926.00000",
        "date_terminated": null,
        "purchased": 0
    }
},
{
    "meta": {
        "docket_no": 925,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "925.00000",
        "date_filed": "04/18/2017",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766532",
        "purchased": 1
    },
    "text": {
        "docket_no": 925,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "925.00000",
        "date_filed": "04/18/2017",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766532"
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766529",
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 924,
        "docket_seq": "924.00000",
        "date_terminated": null,
        "date_filed": "04/18/2017",
        "case_uuid": "debke_156594",
        "purchased": 1
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016766529",
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 924,
        "docket_seq": "924.00000",
        "date_terminated": null,
        "date_filed": "04/18/2017",
        "case_uuid": "debke_156594"
    }
},
{
    "text": {
        "docket_uri": null,
        "docket_seq": "923.00000",
        "date_terminated": null,
        "timestamp": 1545950336.76245,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 923,
        "case_uuid": "debke_156594",
        "date_filed": "04/17/2017"
    },
    "meta": {
        "docket_uri": null,
        "docket_seq": "923.00000",
        "date_terminated": null,
        "timestamp": 1545950336.76245,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 923,
        "case_uuid": "debke_156594",
        "date_filed": "04/17/2017",
        "purchased": 0
    }
},
{
    "text": {
        "docket_no": 922,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.72731,
        "docket_seq": "922.00000",
        "date_terminated": null,
        "date_filed": "04/03/2017",
        "case_uuid": "debke_156594",
        "docket_uri": null
    },
    "meta": {
        "docket_no": 922,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.72731,
        "docket_seq": "922.00000",
        "date_terminated": null,
        "date_filed": "04/03/2017",
        "case_uuid": "debke_156594",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "meta": {
        "docket_uri": null,
        "docket_seq": "921.00000",
        "date_terminated": null,
        "timestamp": 1545950336.69215,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 921,
        "case_uuid": "debke_156594",
        "date_filed": "03/20/2017",
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "docket_seq": "921.00000",
        "date_terminated": null,
        "timestamp": 1545950336.69215,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 921,
        "case_uuid": "debke_156594",
        "date_filed": "03/20/2017"
    }
},
{
    "meta": {
        "docket_uri": null,
        "docket_no": 920,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.6532,
        "docket_seq": "920.00000",
        "date_terminated": null,
        "date_filed": "03/06/2017",
        "case_uuid": "debke_156594",
        "purchased": 0
    },
    "text": {
        "docket_uri": null,
        "docket_no": 920,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.6532,
        "docket_seq": "920.00000",
        "date_terminated": null,
        "date_filed": "03/06/2017",
        "case_uuid": "debke_156594"
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664123",
        "timestamp": 1545958158.50098,
        "docket_text": "Order (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009) Affirming Order Denying Application of Leidos Engineering, LLC for Allowance and Payment of Claims for Substantial Contribution. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015573506'>793</a>) Order Signed on 2/27/2017. (DMC)",
        "docket_no": 919,
        "docket_seq": "919.00000",
        "date_terminated": null,
        "date_filed": "02/27/2017",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664123",
        "timestamp": 1545958158.50098,
        "docket_text": "Order (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009) Affirming Order Denying Application of Leidos Engineering, LLC for Allowance and Payment of Claims for Substantial Contribution. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015573506'>793</a>) Order Signed on 2/27/2017. (DMC)",
        "docket_no": 919,
        "docket_seq": "919.00000",
        "date_terminated": null,
        "date_filed": "02/27/2017",
        "case_uuid": "debke_156594",
        "purchased": 1
    }
},
{
    "meta": {
        "timestamp": 1545958158.50098,
        "docket_no": 918,
        "docket_text": "Memorandum Opinion (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009). (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015605009'>798</a>) (DMC) Modified Text on 2/28/2017 (LB).",
        "date_terminated": null,
        "docket_seq": "918.00000",
        "date_filed": "02/27/2017",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664083",
        "purchased": 1
    },
    "text": {
        "timestamp": 1545958158.50098,
        "docket_no": 918,
        "docket_text": "Memorandum Opinion (COPY FROM DISTRICT COURT) (BAP 15-62) (Civ No. 15-1009). (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042015605009'>798</a>) (DMC) Modified Text on 2/28/2017 (LB).",
        "date_terminated": null,
        "docket_seq": "918.00000",
        "date_filed": "02/27/2017",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016664083"
    }
},
{
    "text": {
        "docket_uri": null,
        "docket_no": 917,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.5202,
        "docket_seq": "917.00000",
        "date_terminated": null,
        "date_filed": "02/21/2017",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": null,
        "docket_no": 917,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.5202,
        "docket_seq": "917.00000",
        "date_terminated": null,
        "date_filed": "02/21/2017",
        "case_uuid": "debke_156594",
        "purchased": 0
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016593791",
        "timestamp": 1545958158.50098,
        "docket_no": 916,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for Quarter Ending December 2016</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016591672'>915</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_seq": "916.00000",
        "date_terminated": null,
        "date_filed": "01/25/2017",
        "case_uuid": "debke_156594"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016593791",
        "timestamp": 1545958158.50098,
        "docket_no": 916,
        "docket_text": "Affidavit/Declaration of Service <i>re: Post-Confirmation Report for Quarter Ending December 2016</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016591672'>915</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_seq": "916.00000",
        "date_terminated": null,
        "date_filed": "01/25/2017",
        "case_uuid": "debke_156594",
        "purchased": 1
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016591672",
        "date_filed": "01/24/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>for Quarter Ending December 2016</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 915,
        "date_terminated": null,
        "docket_seq": "915.00000"
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016591672",
        "date_filed": "01/24/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_text": "Post-Confirmation Report <i>for Quarter Ending December 2016</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 915,
        "date_terminated": null,
        "docket_seq": "915.00000",
        "purchased": 1
    }
},
{
    "meta": {
        "docket_no": 914,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.39512,
        "docket_seq": "914.00000",
        "date_terminated": null,
        "date_filed": "01/23/2017",
        "case_uuid": "debke_156594",
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "docket_no": 914,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.39512,
        "docket_seq": "914.00000",
        "date_terminated": null,
        "date_filed": "01/23/2017",
        "case_uuid": "debke_156594",
        "docket_uri": null
    }
},
{
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016578003",
        "case_uuid": "debke_156594",
        "date_filed": "01/17/2017",
        "date_terminated": null,
        "docket_seq": "913.00000",
        "docket_text": "Affidavit/Declaration of Service <i>of Barbara J. Witters (Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016548588'>911</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 913,
        "timestamp": 1545958158.50098,
        "purchased": 1
    },
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016578003",
        "case_uuid": "debke_156594",
        "date_filed": "01/17/2017",
        "date_terminated": null,
        "docket_seq": "913.00000",
        "docket_text": "Affidavit/Declaration of Service <i>of Barbara J. Witters (Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016548588'>911</a>) Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_no": 913,
        "timestamp": 1545958158.50098
    }
},
{
    "text": {
        "date_filed": "01/09/2017",
        "case_uuid": "debke_156594",
        "docket_no": 912,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.31047,
        "date_terminated": null,
        "docket_seq": "912.00000",
        "docket_uri": null
    },
    "meta": {
        "date_filed": "01/09/2017",
        "case_uuid": "debke_156594",
        "docket_no": 912,
        "docket_text": "Standing Order/Transcripts",
        "timestamp": 1545950336.31047,
        "date_terminated": null,
        "docket_seq": "912.00000",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "meta": {
        "date_filed": "01/03/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 911,
        "docket_text": "Post-Confirmation Report <i>(Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_seq": "911.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016548588",
        "purchased": 1
    },
    "text": {
        "date_filed": "01/03/2017",
        "case_uuid": "debke_156594",
        "timestamp": 1545958158.50098,
        "docket_no": 911,
        "docket_text": "Post-Confirmation Report <i>(Post-Confirmation Quarterly Report for the Reporting Period September 2016)</i> Filed by KiOR, Inc.. (Steele, Amanda)",
        "docket_seq": "911.00000",
        "date_terminated": null,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016548588"
    }
},
{
    "meta": {
        "timestamp": 1545950336.17571,
        "docket_no": 910,
        "docket_text": "Standing Order/Transcripts",
        "date_terminated": null,
        "docket_seq": "910.00000",
        "date_filed": "12/27/2016",
        "case_uuid": "debke_156594",
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "timestamp": 1545950336.17571,
        "docket_no": 910,
        "docket_text": "Standing Order/Transcripts",
        "date_terminated": null,
        "docket_seq": "910.00000",
        "date_filed": "12/27/2016",
        "case_uuid": "debke_156594",
        "docket_uri": null
    }
},
{
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "12/19/2016",
        "date_terminated": null,
        "docket_seq": "909.00000",
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 909,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521188",
        "purchased": 1
    },
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "12/19/2016",
        "date_terminated": null,
        "docket_seq": "909.00000",
        "timestamp": 1545958158.50098,
        "docket_text": "Quarterly Claims Register <i>Numerical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_no": 909,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521188"
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "12/19/2016",
        "date_terminated": null,
        "docket_seq": "908.00000",
        "timestamp": 1545958158.50098,
        "docket_no": 908,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521165"
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "12/19/2016",
        "date_terminated": null,
        "docket_seq": "908.00000",
        "timestamp": 1545958158.50098,
        "docket_no": 908,
        "docket_text": "Quarterly Claims Register <i>Alphabetical</i>. Filed by Epiq Bankruptcy Solutions LLC. (Persaud, Tony)",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016521165",
        "purchased": 1
    }
},
{
    "text": {
        "docket_seq": "907.00000",
        "date_terminated": null,
        "timestamp": 1545950336.00561,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 907,
        "case_uuid": "debke_156594",
        "date_filed": "12/12/2016",
        "docket_uri": null
    },
    "meta": {
        "docket_seq": "907.00000",
        "date_terminated": null,
        "timestamp": 1545950336.00561,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 907,
        "case_uuid": "debke_156594",
        "date_filed": "12/12/2016",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "meta": {
        "timestamp": 1545958158.50098,
        "docket_text": "Amended Certificate of Service <i>to Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016482208'>904</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042016482462'>905</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
        "docket_no": 906,
        "docket_seq": "906.00000",
        "date_terminated": null,
        "date_filed": "12/02/2016",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016484635",
        "purchased": 1
    },
    "text": {
        "timestamp": 1545958158.50098,
        "docket_text": "Amended Certificate of Service <i>to Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016482208'>904</a>, <a href='https://ecf.deb.uscourts.gov/doc1/042016482462'>905</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
        "docket_no": 906,
        "docket_seq": "906.00000",
        "date_terminated": null,
        "date_filed": "12/02/2016",
        "case_uuid": "debke_156594",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016484635"
    }
},
{
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "12/01/2016",
        "date_terminated": null,
        "docket_seq": "905.00000",
        "docket_no": 905,
        "docket_text": "Certificate of Service <i>to Order Approving the Claim of Matheson Tri-Gas, Inc.</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482462",
        "purchased": 1
    },
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "12/01/2016",
        "date_terminated": null,
        "docket_seq": "905.00000",
        "docket_no": 905,
        "docket_text": "Certificate of Service <i>to Order Approving the Claim of Matheson Tri-Gas, Inc.</i> Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Devan, Emily)",
        "timestamp": 1545958158.50098,
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482462"
    }
},
{
    "text": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482208",
        "case_uuid": "debke_156594",
        "date_filed": "12/01/2016",
        "docket_seq": "904.00000",
        "date_terminated": null,
        "docket_no": 904,
        "docket_text": "Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Order Signed on 12/1/2016. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116482209'>1</a> Exhibit A) (DMC)",
        "timestamp": 1545958158.50098
    },
    "meta": {
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016482208",
        "case_uuid": "debke_156594",
        "date_filed": "12/01/2016",
        "docket_seq": "904.00000",
        "date_terminated": null,
        "docket_no": 904,
        "docket_text": "Order Approving Stipulation Regarding The Claim of Matheson Tri-Gas, Inc. (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Order Signed on 12/1/2016. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116482209'>1</a> Exhibit A) (DMC)",
        "timestamp": 1545958158.50098,
        "purchased": 1
    }
},
{
    "text": {
        "date_filed": "11/29/2016",
        "case_uuid": "debke_156594",
        "docket_no": 903,
        "docket_text": "Certification of Counsel <i>Regarding Stipulation Regarding the Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116474818'>1</a> Exhibit 1) (Devan, Emily)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "903.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016474817"
    },
    "meta": {
        "date_filed": "11/29/2016",
        "case_uuid": "debke_156594",
        "docket_no": 903,
        "docket_text": "Certification of Counsel <i>Regarding Stipulation Regarding the Claim of Matheson Tri-Gas, Inc.</i> (related document(s)<a href='https://ecf.deb.uscourts.gov/doc1/042016343159'>894</a>) Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116474818'>1</a> Exhibit 1) (Devan, Emily)",
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "903.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016474817",
        "purchased": 1
    }
},
{
    "text": {
        "date_filed": "11/28/2016",
        "case_uuid": "debke_156594",
        "docket_text": "HEARING CANCELLED/RESCHEDULED. Notice of Agenda of Matters Scheduled for Hearing. Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 11/30/2016 at 11:00 AM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116472467'>1</a> Certificate of Service) (Devan, Emily)",
        "docket_no": 902,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "902.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016472466"
    },
    "meta": {
        "date_filed": "11/28/2016",
        "case_uuid": "debke_156594",
        "docket_text": "HEARING CANCELLED/RESCHEDULED. Notice of Agenda of Matters Scheduled for Hearing. Filed by KURT F. GWYNNE, LIQUIDATING TRUSTEE. Hearing scheduled for 11/30/2016 at 11:00 AM at US Bankruptcy Court, 824 Market St., 5th Fl., Courtroom &#035;6, Wilmington, Delaware. (Attachments: # <a href='https://ecf.deb.uscourts.gov/doc1/042116472467'>1</a> Certificate of Service) (Devan, Emily)",
        "docket_no": 902,
        "timestamp": 1545958158.50098,
        "date_terminated": null,
        "docket_seq": "902.00000",
        "docket_uri": "https://ecf.deb.uscourts.gov/doc1/042016472466",
        "purchased": 1
    }
},
{
    "meta": {
        "date_terminated": null,
        "docket_seq": "901.00000",
        "timestamp": 1545950335.67558,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 901,
        "case_uuid": "debke_156594",
        "date_filed": "11/28/2016",
        "docket_uri": null,
        "purchased": 0
    },
    "text": {
        "date_terminated": null,
        "docket_seq": "901.00000",
        "timestamp": 1545950335.67558,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 901,
        "case_uuid": "debke_156594",
        "date_filed": "11/28/2016",
        "docket_uri": null
    }
},
{
    "text": {
        "date_filed": "11/14/2016",
        "case_uuid": "debke_156594",
        "timestamp": 1545950335.64627,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 900,
        "date_terminated": null,
        "docket_seq": "900.00000",
        "docket_uri": null
    },
    "meta": {
        "date_filed": "11/14/2016",
        "case_uuid": "debke_156594",
        "timestamp": 1545950335.64627,
        "docket_text": "Standing Order/Transcripts",
        "docket_no": 900,
        "date_terminated": null,
        "docket_seq": "900.00000",
        "docket_uri": null,
        "purchased": 0
    }
},
{
    "text": {
        "case_uuid": "debke_156594",
        "date_filed": "10/31/2016",
        "date_terminated": null,
        "docket_seq": "899.00000",
        "timestamp": 1545950335.60894,
        "docket_no": 899,
        "docket_text": "Standing Order/Transcripts",
        "docket_uri": null
    },
    "meta": {
        "case_uuid": "debke_156594",
        "date_filed": "10/31/2016",
        "date_terminated": null,
        "docket_seq": "899.00000",
        "timestamp": 1545950335.60894,
        "docket_no": 899,
        "docket_text": "Standing Order/Transcripts",
        "docket_uri": null,
        "purchased": 0
    }
}
];


// WEBPACK FOOTER //
// ./src/components/case/history/HistoryArray.js